<template>
    <div class="banner">
        <avideo :srcs="src" poster="/assets/banners/horses.jpg"/>
        <div class="inner">
            <div class="container">
                <div class="title" v-html="$t('banners.horses.title')"></div>
                <silentbox-single class="button button-lg" :src="$t('banners.horses.link')">{{$t('banners.horses.button')}}</silentbox-single>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BannerHorses',
    data (){
        return {
            src : ["/assets/banners/horses.webm", "/assets/banners/horses.mp4"]
        }
    }    
}
</script>

<style lang="scss" scoped>
    .title {
        font-size: 1rem;
        text-transform: uppercase;
        text-shadow: 1px 3px 0 $black, 1px 3px 5px $black;
    }

    .button {
        margin-top: $spacer;
    }
</style>
